import classNames from 'classnames';
import React from 'react';
import * as styles from './AnnotationPreview.module.scss';
import DeltaPreview from '../../components/DeltaPreview';
import { MentionBaseProvider } from '../../editor/mentions/MentionBase';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import Link from '../../utils/router/Link';
import MagneticWallItem from '../MagneticWallItem';
import isContentEmpty from '../utils/isContentEmpty';

const ANNOTATION_PREVIEW_FRAGMENT = gql(`
  fragment AnnotationPreview_annotation on Annotation {
    id
    content
    link
    linkText
  }
`);

interface AnnotationPreviewProps {
  annotation: DocumentType<typeof ANNOTATION_PREVIEW_FRAGMENT>;
  avatar: React.ReactNode;
}

const AnnotationPreview = ({ annotation, avatar }: AnnotationPreviewProps) => {
  return (
    <MagneticWallItem.WithAvatar
      avatar={avatar}
      innerTestId="annotation-preview-content"
    >
      {isContentEmpty(annotation.content) ? (
        <Link className={styles.link} to={annotation.link ?? '#'} newTab>
          {annotation.linkText ?? annotation.link ?? ''}
        </Link>
      ) : (
        <div
          className={classNames('annotation-preview', styles.annotationPreview)}
        >
          <MentionBaseProvider containerType="comment">
            <DeltaPreview typography="comment" content={annotation.content} />
          </MentionBaseProvider>
        </div>
      )}
    </MagneticWallItem.WithAvatar>
  );
};

export default AnnotationPreview;
